import AnimatedSection from '../../../components/base/AnimatedSection';
import { services } from '../../../mocks/services';

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <AnimatedSection animation="fadeUp" className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 rounded-full text-teal-600 mb-5 border border-teal-100">
            <i className="ri-service-line"></i>
            <span className="text-sm font-medium">核心服務</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            全方位 AI 數位轉型服務
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            從數據洞察到流程自動化，我們提供端到端的 AI 解決方案，協助企業在數位時代持續成長。
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <AnimatedSection key={service.id} animation="fadeUp" delay={index * 120}>
              <div className="group bg-white rounded-2xl p-8 border border-gray-100 hover:shadow-2xl hover:shadow-teal-500/10 transition-all duration-500 hover:-translate-y-2 h-full flex flex-col">
                <div className={`w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br ${service.color} mb-6 shadow-lg group-hover:scale-110 transition-transform duration-500`}>
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                <div className="mb-2">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{service.title}</h3>
                  <p className="text-xs text-gray-400 font-medium">{service.subtitle}</p>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mb-6 flex-1">
                  {service.description}
                </p>
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature) => (
                    <li key={feature} className="flex items-center gap-2 text-sm text-gray-600">
                      <div className={`w-4 h-4 flex items-center justify-center rounded-full bg-gradient-to-br ${service.color} flex-shrink-0`}>
                        <i className="ri-check-line text-white text-xs"></i>
                      </div>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
